import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Table,
  Button,
  Flex,
  Typography,
  ConfigProvider,
  Dropdown,
  Menu,
  Modal,
  Popover,
  Select,
  Input,
  Checkbox,
  Tooltip,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import AddTaskModal from "../Dailogs/AddTaskModal";
import {
  AddForm,
  fetchFormsByProject,
  FetchTaskByProject,
  fetchFormById,
  linkFormToProject,
  unlinkFormToProject,
  linkTaskToForm,
  fetchTemplateForms,
  GlobalRequest,
} from "../../redux/actions/action";
import {
  EyeOutlined,
  PlusCircleOutlined,
  CopyOutlined,
  ImportOutlined,
  DeleteOutlined,
  BorderHorizontalOutlined,
  EditOutlined,
  ArrowRightOutlined,
  CloseCircleOutlined,
  SearchOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { API_URL } from "../../redux/constants/type";
import assignWork from "../../assets/icons/assignWork.svg";
import sendToClient from "../../assets/icons/sendToClient.svg";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const styles = {
  mainContainer: {
    backgroundColor: "white",
    padding: "15px",
    borderRadius: "10px",
    minHeight: "55vh",
  },
  tableToolbarContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    // gap: "10px",
    width: "100%",
    margin: "0 0 10px 0",
  },
  addFormContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
    width: "8rem",
    marginLeft: "10px",
  },
  addFormButton: {
    borderRadius: "50%",
    backgroundColor: "#00246a",
    color: "white",
    height: "2rem",
    width: "2rem",
  },
  addForm: {
    fontWeight: "300",
    color: "#00246a",
    margin: "0",
    fontSize: "13px",
  },
  dropDownMenuItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
  },
  assignContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  assignButton: {
    backgroundColor: "#e4edfa",
    color: "#00246a",
    fontSize: "12px",
    padding: "0 30px",
    fontSize: "10px",
    fontWeight: "600",
    height: "24px",
    marginRight: "75px",
  },
  popOver: (h, w) => {
    return {
      minWidth: w,
      position: "relative",
      minHeight: h,
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "20px",
    };
  },
  closeIcon: {
    position: "absolute",
    top: "0",
    // height: "30px",
    // width: "30px",
    right: "0",
    color: "#a5a5a5",
  },
  importButton: {
    padding: "0 26px",
    height: "28px",
    fontSize: "12px",
    fontWeight: "600",
    position: "absolute",
    bottom: "10px",
    left: "35%",
  },
  assignWorkContainerTitle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyConntent: "space-between",
    gap: "20px",
    position: "absolute",
    backgroundColor: "#f1f1f1",
    width: "23.25rem",
    left: "-11px",
    top: "-11px",
    borderRadius: "10px 10px 0 0",
    padding: "10px",
  },
  addTask: {
    cursor: "pointer",
    fontSize: "1.5rem",
    lineHeight: "1.5rem",

    color: "#00246a",
  },
  searchInput: {
    backgroundColor: "inherit",
    borderRadius: "10px",
    // width: "10rem",
  },
  checkboxContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "10px",
    maxHeight: "400px",
    overflow: "scroll",
    marginTop: "50px",
    width: "100%",
  },
  paginationContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
  },
  paginationIcon: {
    cursor: "pointer",
    color: "#a5a5a5",
    height: "12px",
    width: "12px",
  },
};

function Index({
  showModal,
  setShowModal,
  taskList,
  setTaskList,
  pageNumber,
  setPageNumber,
  itemsPerPage,
  setItemsPerPage,
  totalPages,
  setTotalPages,
  totalItems,
  setTotalItems,
  pagesArray,
  setPagesArray,
  popups,
  setPopups,
  textAreaRef,
  reRenderAPI,
  setReRenderAPI,
  val,
  setVal,
  modalFunctionNoty,
  setModalFunctionNoty,
  modelTypeId,
  setModelTypeId,
  taskid,
  setTaskid,
  comments,
  setComments,
  minComments,
  setMinComments,
  maxComments,
  setMaxComments,
  modalFunction,
  setModalFunction,
  enablecomm,
  setEnableComm,
  showcmnt,
  setShowcmnt,
  message,
  setMessage,
  inputFile,
  imgUrl,
  setImgUrl,
  attachMessage,
  setAttachMessage,
  taggedUser,
  setTaggedUser,
  show,
  setShow,
  length,
  setLength,
  from,
  setFrom,
  searchText,
  setSearchText,
  showError,
  setShowError,
  statusList,
  setStatusList,
  isBasicMember,
  setIsBasicMember,
  isBuildingBlock,
  setIsBuildingBlock,
  onButtonClick,
  handleAddComments,
  handleFileChange,
  fetchComments,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const projectId = window.localStorage.getItem("projectid");
  const [tableLoading, setTableLoading] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedForm, setSelectedForm] = useState(null);
  const [paginatedForms, setPaginatedForms] = useState(10);
  const [finalFormList, setFinalFormList] = useState([]);
  const [formId, setFormId] = useState("");
  const formIdRef = useRef();
  const [showTaskMoadal, setShowTaskModal] = useState(false);
  const [formName, setFormName] = useState("");

  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions
  );

  const deleteTaskResponse = useSelector(
    (state) => state.user.deleteTaskResponse
  );
  const UpdatePOTaskStatusResponse = useSelector(
    (state) => state.user.UpdatePOTaskStatusResponse
  );
  const changeStatus = useSelector((state) => state.user.changeStatus);
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  const getTaskStatusListRes = useSelector(
    (state) => state.user.getTaskStatusListRes
  );

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      const isBasicPlan =
        getAppSideNavOptions &&
        Array.isArray(getAppSideNavOptions) &&
        getAppSideNavOptions.every(
          (x) =>
            x.packageName.toUpperCase() == "BASIC" &&
            x.packageId == process.env.REACT_APP_IS_BASIC
        );
      setIsBasicMember(isBasicPlan);

      const isBuildingBlockVal =
        getAppSideNavOptions &&
        Array.isArray(getAppSideNavOptions) &&
        getAppSideNavOptions.every(
          (x) => x.packageId == process.env.REACT_APP_IS_PREMIUM
        );
      setIsBuildingBlock(isBuildingBlockVal);
    }
  }, [getAppSideNavOptions]);

  const {
    formsByProject,
    fetchTaskByProjectResponse,
    formList,
    templateForms,
  } = useSelector((state) => state.user);

  const handleTaskSelect = useCallback(
    (task) => {
      setSelectedTask(task);
      dispatch(
        linkTaskToForm({
          formId: selectedForm?.formId,
          taskId: task?.taskid,
          projectId,
        })
      ).then((res) => {
        if (res?.status === true) {
          fetchForms();
        }
      });
    },
    [selectedForm]
  );

  const handleImportForm = (id, setIsOpen) => {
    let form = templateForms?.data?.find(
      (form) => form?.formid === formIdRef.current
    );
    const updatedSections = form?.sections?.map((section) => {
      delete section.formSectionid;
      const updatedChildren = section.children
        ? section.children.map((child) => {
            delete child.sectionFieldid;
            delete child.parentId;
            const updatedOptions = child.options
              ? child.options.map((opt) => {
                  return { optionName: opt };
                })
              : [];
            const updatedChild = child.options
              ? { ...child, options: updatedOptions }
              : { ...child };
            return { ...updatedChild };
          })
        : [];
      const updatedSection = section.children
        ? { ...section, children: updatedChildren }
        : { ...section };
      return { ...updatedSection };
    });
    delete form.formid;
    dispatch(
      AddForm({
        ...form,
        sections: updatedSections,
        projectId,
        status: "",
      })
    ).then((res) => {
      if (res?.status === true) {
        fetchForms();
        setIsOpen(false);
      }
    });
  };

  useEffect(() => {
    formIdRef.current = formId;
  }, [formId]);

  const changePagination = (mode) => {
    if (mode === "left") {
      if (paginatedForms <= 10) return;
      setPaginatedForms((prev) => prev - 10);
    } else if (mode === "right") {
      if (paginatedForms >= formsByProject?.data?.length) return;
      setPaginatedForms((prev) => prev + 10);
    }
  };

  useEffect(() => {
    dispatch(
      GlobalRequest({
        url: `${API_URL}/api/Stage/GetTaskStatusDropdownList`,
        method: "get",
        state: "getTaskStatusListRes",
        data: {},
      })
    );
  }, []);

  useEffect(() => {
    if (getTaskStatusListRes?.status === true) {
      setStatusList(getTaskStatusListRes?.data);
    }
  }, [getTaskStatusListRes]);

  useEffect(() => {
    // if (location?.pathname === "/updateProject") {
    if (location?.pathname.startsWith("/project/")) {
      dispatch(FetchTaskByProject(projectId, pageNumber, itemsPerPage));
    }
  }, [location, pageNumber]);

  const initialRender5 = React.useRef(true);
  React.useEffect(() => {
    if (!initialRender5.current) {
      if (comments != null) {
        if (comments.status == true) {
          setMinComments([]);
          setShow(comments.data);
          setLength(comments.data.length);
          for (var i = 0; i < 5; i++) {
            minComments.push(comments.data[i]);
          }
          setMaxComments(minComments.filter((item) => item != undefined));
        } else {
        }
      }
    } else {
      initialRender5.current = false;
    }
  }, [comments]);

  useEffect(() => {
    if (fetchTaskByProjectResponse?.status === true) {
      setTaskList(fetchTaskByProjectResponse?.data);

      // ASC for toggle start
      let filterdItem = fetchTaskByProjectResponse?.data
        .filter((x) => x.statusname === "Complete")
        .map((item) => {
          return {
            // pushedName: item.statusname,
            pushedName: item.taskname,
            pushedID: item.taskid,
          };
        });
      // setSelectedToggle(filterdItem);
      // ASC for toggle end

      let pages = Math.ceil(
        fetchTaskByProjectResponse?.totalCount / itemsPerPage
      );
      setTotalPages(pages);
      setTotalItems(fetchTaskByProjectResponse?.totalCount);
      let array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      setPagesArray([...array]);
    }
  }, [fetchTaskByProjectResponse]);

  useEffect(() => {
    if (taskid) {
      fetchComments(taskid);
    }
  }, [taskid]);

  useEffect(() => {
    if (changeStatus?.status === true) {
      dispatch(FetchTaskByProject(projectId, pageNumber, itemsPerPage));
    }
  }, [changeStatus]);

  useEffect(() => {
    if (deleteTaskResponse?.status === true) {
      dispatch(FetchTaskByProject(projectId, pageNumber, itemsPerPage));
    }
  }, [deleteTaskResponse]);

  const menuItems = [
    {
      key: "create",
      label: (
        <div style={styles.dropDownMenuItem}>
          <CopyOutlined />
          {/* Create Form */}
          {t("Create Form")}
        </div>
      ),
      onClick: () => {
        localStorage.setItem(
          "projectDetails",
          JSON.stringify({ projectId, status: "" }),
        );
        history.push({
          pathname: "/form-builder",
          state: { formPopUp: true },
        });
      },
    },
    {
      key: "import",
      label: (
        <FormSelectionPopover
          onImport={handleImportForm}
          formId={formId}
          setFormId={setFormId}
          formList={templateForms}
          setFetchTranslationList={setFetchTranslationList}
          FetchTranslationList={FetchTranslationList}
        />
      ),
      onClick: () => {},
    },
  ];

  const actionableMenu = [
    {
      key: "assign",
      label: (
        <>
          <TaskSelectionPopover
            onTaskSelect={handleTaskSelect}
            tasks={fetchTaskByProjectResponse?.data || []}
            setModalFunction={setModalFunction}
            setShowModal={setShowModal}
            setFetchTranslationList={setFetchTranslationList}
            FetchTranslationList={FetchTranslationList}
          />
        </>
      ),
      onClick: () => {},
    },
    // {
    //   key: "send",
    //   label: (
    //     <div style={styles.dropDownMenuItem}>
    //       <img
    //         src={sendToClient}
    //         alt=""
    //         style={{ height: "16px", width: "16px" }}
    //       />{" "}
    //       {/* Send to Client */}
    //       {FetchTranslationList[219]?.translation}
    //     </div>
    //   ),
    //   onClick: () => {},
    // },
    {
      key: "edit",
      label: (
        <div style={styles.dropDownMenuItem}>
          <EditOutlined />
          {/* Edit Form */}
          {t("Edit Form")}
        </div>
      ),
      onClick: () => {
        history.push({
          pathname: "/form-builder",
          state: { formPopUp: false },
        });
        localStorage.setItem("formCondition", false);
        dispatch(fetchFormById(selectedForm?.formId));
      },
    },
    {
      key: "delete",
      label: (
        <div style={styles.dropDownMenuItem}>
          <DeleteOutlined />
          {/* Delete */}
          {t("Delete")}
        </div>
      ),
      onClick: () => {
        dispatch(
          unlinkFormToProject({
            projectId,
            formId: selectedForm?.formId,
          }),
        ).then((res) => {
          if (res?.status === true) fetchForms();
        });
      },
    },
  ];

  const columns = [
    {
      // title: "Form Name",
      title: t("Form Name "),
      key: "formName",
      dataIndex: "formName",
      render: (formName, res) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "10px",
              color: "#656565",
            }}
          >
            <EyeOutlined
              style={{ cursor: "pointer" }}
              onClick={() => {
                history.push({
                  pathname: "/form-builder",
                  state: { formPopUp: false },
                });
                localStorage.setItem("formCondition", false);

                dispatch(fetchFormById(res?.formId));
              }}
            />
            {formName}
          </div>
        );
      },
      width: "40%",
    },
    {
      // title: "Actions",
      title: t("Actions"),
      key: "actions",
      render: (select, res) => {
        return (
          <Dropdown
            menu={{
              items: res?.taskname
                ? actionableMenu.filter((menuItem) => menuItem.key !== "assign")
                : actionableMenu,
            }}
            trigger={["click"]}
          >
            <div
              style={{ cursor: "pointer" }}
              onClick={() => setSelectedForm(res)}
            >
              {res?.taskname ? (
                <div style={styles.dropDownMenuItem}>
                  {" "}
                  <img
                    src={assignWork}
                    alt=""
                    style={{ height: "16px", width: "16px" }}
                  />{" "}
                  {/* Assign to work */}
                  {t("Assign To Work")}
                </div>
              ) : (
                // "Select"
                t("Select")
              )}
            </div>
          </Dropdown>
        );
      },
      width: "15%",
    },
    {
      // title: "Status",
      title: t("Status"),
      key: "status",
      dataIndex: "taskname",
      render: (task, res) => {
        return (
          <>
            {task ? (
              <div style={styles.assignContainer}>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setTaskid(res?.taskid);
                    localStorage.setItem("formName", res?.formName);
                    localStorage.setItem("formId", res?.formId);
                    setModalFunction("update");
                    setShowModal(true);
                  }}
                >{`Task : ${task}`}</div>
                <Button style={styles.assignButton} disabled>
                  Assigned
                </Button>
              </div>
            ) : (
              "-"
            )}
          </>
        );
      },
      width: "45%",
    },
  ];

  async function fetchForms() {
    setTableLoading(true);
    const res = await Promise.resolve(dispatch(fetchFormsByProject(projectId)));
    if (res?.status === true) setTableLoading(false);
  }

  useEffect(() => {
    fetchForms();
    dispatch(FetchTaskByProject(projectId, 1, 1000));
    dispatch(fetchTemplateForms());
  }, []);

  useEffect(() => {
    if (
      formsByProject &&
      formsByProject.data &&
      Array.isArray(formsByProject.data)
    ) {
      const list = formsByProject.data.slice(
        paginatedForms - 10,
        paginatedForms
      );
      console.log(list);
      setFinalFormList(list);
    }
  }, [paginatedForms, formsByProject]);

  useEffect(() => {
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  return (
    <>
      <div style={styles.mainContainer}>
        <Flex align="center" style={styles.tableToolbarContainer}>
          <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
            <div style={styles.addFormContainer}>
              <Button style={styles.addFormButton}>+</Button>
              <Typography.Title type="primary" level={5} style={styles.addForm}>
                {/* Add Form */}
                {t("Add Form")}
              </Typography.Title>
            </div>
          </Dropdown>
          <div style={styles.paginationContainer}>
            <span style={{ color: "#a5a5a5", fontSize: "12px" }}>{`${
              paginatedForms - 9
            } - ${
              paginatedForms < formsByProject?.data?.length
                ? paginatedForms
                : formsByProject?.data?.length
            } of ${formsByProject?.data?.length}`}</span>
            <LeftOutlined
              style={styles.paginationIcon}
              onClick={changePagination.bind(null, "left")}
            />
            <div style={{ fontSize: "12px" }}>
              {" "}
              {Math.ceil(paginatedForms / 10)}
            </div>
            <RightOutlined
              style={styles.paginationIcon}
              onClick={changePagination.bind(null, "right")}
            />
          </div>
        </Flex>
        <ConfigProvider
          theme={{
            components: {
              Table: {
                headerBg: "white",
                headerColor: "#a5a5a5",
                colorText: "#a5a5a5",
                padding: 5,
                fontSize: 13,
              },
            },
          }}
        >
          <Table
            loading={tableLoading}
            columns={columns}
            dataSource={finalFormList ? finalFormList : []}
            pagination={false}
          />
        </ConfigProvider>
      </div>
      <AddTaskModal
        isBasicMember={isBasicMember}
        isBuildingBlock={isBuildingBlock}
        val={val}
        setVal={setVal}
        textAreaRef={textAreaRef}
        modelTypeId={modelTypeId}
        showModal={showModal}
        modalFunctionNoty={modalFunctionNoty}
        setTaskid={setTaskid}
        taskid={taskid}
        setShowModal={(show, reload) => {
          setShowModal(false);
          window.localStorage.removeItem("taskid");
        }}
        setComments={setComments}
        modalFunction={modalFunction}
        setModalFunction={setModalFunction}
        setEnableComm={setEnableComm}
        setShowcmnt={setShowcmnt}
        enablecomm={enablecomm}
        showcmnt={showcmnt}
        setMessage={setMessage}
        message={message}
        onButtonClick={onButtonClick}
        handleFileChange={handleFileChange}
        handleAddComments={handleAddComments}
        maxComments={maxComments}
        taggedUser={taggedUser}
        setTaggedUser={setTaggedUser}
        show={show}
        length={length}
        setLength={setLength}
        setShow={setShow}
        imgUrl={imgUrl}
        setImgUrl={setImgUrl}
        setMaxComments={setMaxComments}
        from={from}
        searchText={searchText}
        setReRenderAPI={setReRenderAPI}
        setPopups={setPopups}
        statusList={statusList}
        formName={formName}
      />
    </>
  );
}

export default Index;

const TaskSelectionPopover = ({
  open,
  onOpenChange,
  onTaskSelect,
  tasks,
  setModalFunction,
  setShowModal,
  FetchTranslationList,
}) => {
  const [searchedTask, setSearchedTask] = useState("");
  const [filteredTasks, setFilteredTasks] = useState(tasks);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState({});
  const newTaskCreated = useSelector((state) => state.user.addTaskResponse);
  const t = (key) => FetchTranslationList?.[key] || "";

  useEffect(() => {
    setFilteredTasks(tasks);
  }, [tasks]);

  useEffect(() => {
    if (newTaskCreated && newTaskCreated.status === true) {
      onTaskSelect(newTaskCreated.data);
    } else return;
  }, [newTaskCreated]);

  const handleSearch = useCallback(
    (value) => {
      setSearchedTask(value);
      const lowercasedValue = value.toLowerCase();
      const filtered = tasks.filter((task) =>
        task?.taskname?.toLowerCase().includes(lowercasedValue)
      );
      setFilteredTasks(filtered);
    },
    [tasks]
  );

  const handleCheckboxChange = useCallback(
    (checked, task) => {
      onTaskSelect(checked ? task : null);
      setSelectedTask(task);
      // setIsOpen(false);
    },
    [onTaskSelect]
  );

  const handleClose = useCallback(() => {
    setIsOpen(false);
    setSearchedTask("");
    setFilteredTasks(tasks);
  }, [tasks]);

  const handleOpenChange = useCallback(
    (newOpen) => {
      setIsOpen(newOpen);
      if (!newOpen) {
        setSearchedTask("");
        setFilteredTasks(tasks);
      }
    },
    [tasks]
  );
  const content = (
    <div style={styles.popOver("200px", "350px")}>
      <div style={styles.assignWorkContainerTitle}>
        <Typography.Title level={5} style={{ margin: 0, fontSize: 12 }}>
          {/* Works/Tasks */}
          {t("Works/Tasks")}
        </Typography.Title>
        <Input
          suffix={<SearchOutlined style={{ cursor: "pointer" }} />}
          placeholder={t("Search")}
          style={styles.searchInput}
          allowClear
          value={searchedTask}
          onChange={(e) => handleSearch(e.target.value)}
        />
        <CloseCircleOutlined
          style={{ cursor: "pointer" }}
          onClick={handleClose}
        />
        <Tooltip title="Add new task">
          <div
            style={styles.addTask}
            onClick={() => {
              setModalFunction("add");
              setShowModal(true);
              setIsOpen(false);
            }}
          >
            +
          </div>
        </Tooltip>
      </div>
      <div style={styles.checkboxContainer}>
        {filteredTasks.map((task) => (
          <Checkbox
            key={task?.taskid}
            onChange={(e) => handleCheckboxChange(e.target.checked, task)}
            checked={task?.taskid === selectedTask?.taskid}
          >
            <div
              onClick={() => {
                setSelectedTask(task);
              }}
            >
              {task?.taskname}
            </div>
          </Checkbox>
        ))}
      </div>
    </div>
  );

  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Popover: {
              zIndexPopup: 1060,
            },
          },
        }}
      >
        <Popover
          content={content}
          trigger="click"
          placement="right"
          arrow={false}
          destroyTooltipOnHide={true}
          open={isOpen}
          onOpenChange={handleOpenChange}
        >
          <div style={styles.dropDownMenuItem}>
            <img
              src={assignWork}
              alt=""
              style={{ height: "16px", width: "16px" }}
            />{" "}
            {/* Assign to work */}
            {t("Assign To Work")}
          </div>
        </Popover>
      </ConfigProvider>
    </>
  );
};

const FormSelectionPopover = ({
  setFormId,
  formId,
  formList,
  onImport,
  FetchTranslationList,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectForm, setSelectForm] = useState("");
  const t = (key) => FetchTranslationList?.[key] || "";

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleOpenChange = useCallback(
    (newOpen) => {
      setIsOpen(newOpen);
      if (!newOpen) {
        // setSearchedTask("");
        // setFilteredTasks(tasks);
      }
    },
    [formId]
  );
  const content = (
    <div style={styles.popOver("125px", "300px")}>
      <CloseCircleOutlined
        style={styles.closeIcon}
        size={60}
        onClick={handleClose}
      />
      <Select
        style={{ width: "100%", height: "3rem", marginTop: "20px" }}
        onChange={(e) => {
          setFormId(e);
        }}
        options={formList?.data?.map((form, i) => {
          return { label: form?.formName, value: form?.formid };
        })}
      />
      <Button
        type="primary"
        style={styles.importButton}
        onClick={onImport.bind(null, formId, setIsOpen)}
      >
        Import
      </Button>
    </div>
  );

  return (
    <ConfigProvider
      theme={{
        components: {
          Popover: {
            zIndexPopup: 1060,
            colorBgElevated: "#f1f1f1",
          },
        },
      }}
    >
      <Popover
        content={content}
        trigger="click"
        placement="right"
        arrow={false}
        destroyTooltipOnHide={true}
        open={isOpen}
        onOpenChange={handleOpenChange}
      >
        <div style={styles.dropDownMenuItem}>
          <ImportOutlined />
          {/* Import Template */}
          {t("Import Template")}
        </div>
      </Popover>
    </ConfigProvider>
  );
};
